import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { localName } from "../../lib/localName";

export const supplierLabel = (supplier, ar) =>
  `${localName(supplier)}${supplier.code ? ` · ${supplier.code}` : ""}`;

// صف مورّد واحد داخل قائمة البحث — تمييز أزرق واضح للاختيار والمرور.
export const SupplierOption = ({ supplier, ar, active, testid, onPick }) => (
  <button
    type="button"
    data-testid={testid}
    className={`flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-start text-xs font-bold transition-colors ${
      active
        ? "bg-blue-500 text-white shadow-neu-in"
        : "text-foreground hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white focus:outline-none"
    }`}
    onClick={() => onPick(supplier)}
  >
    <Check className={`h-3.5 w-3.5 shrink-0 ${active ? "" : "opacity-0"}`} />
    <span className="min-w-0 flex-1 truncate">{supplierLabel(supplier, ar)}</span>
    <span className={`num font-mono text-[10px] ${active ? "text-white/80" : "text-muted-foreground"}`}>
      {supplier.tax?.trn || ""}
    </span>
  </button>
);

export const SupplierEmpty = ({ testid }) => {
  const { t } = useTranslation();
  return (
    <p className="px-3 py-2 text-xs text-muted-foreground" data-testid={testid}>
      {t("purchases.noSupplierMatch")}
    </p>
  );
};
